<template>
  <!-- <div class="text-center h3 mt-4 mb-4" v-if="isloading">Loading...</div> -->
  <!-- <div class="text-center" v-else-if="!isloading && servermessages.length > 0">
    <ul class="messages alert alert-warning" v-if="servermessages.length > 0">
      <li v-for="message in servermessages" :key="message">
        {{ message }}
      </li>
    </ul>
  </div> -->
  <base-spinner :open="isloading"></base-spinner>
  <base-message
  v-if="!isloading"
  :servermessages="servermessages"
  ></base-message>

  <div class="site__body" v-if="content != '' && !isloading">
    <div class="block-space block-space--layout--spaceship-ledge-height"></div>
    <div class="block faq">
      <div class="container container--max--xl">
        <!-- Insert content here -->
        <div v-html="content"></div>
        <div class="faq__footer" v-html="row2cont">
          
        </div>
      </div>
    </div>
    <div class="block-space block-space--layout--before-footer"></div>
  </div>
  <div class="text-center mt-4 mb-4" v-if="content === '' && !isloading">Content Unavailable.</div>
</template>


<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
  data() {
    return {
      content: "",
      row2cont: "",
      isloading: false,
      error: "",
      servermessages: [],
    };
  },
  methods: {
    getContent() {
      this.isloading = true;
      this.content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "ABOUTUS",
                },
                LW3PAGLSD: {
                  value: "MAIN",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },
    getRow2Content() {
      this.isloading = true;
      this.content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "ABOUTUS",
                },
                LW3PAGLSD: {
                  value: "ROW2CONT",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.row2cont = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },
  },
  mounted() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
    
    let tmout = 500;
    if (this.$store.getters.storefront == ''){
        tmout = 2000;
    }
    setTimeout(() => {
      this.getContent();
      this.getRow2Content();
    }, tmout);

  },
};
</script>